import { createUseStyles } from "react-jss";
import arrow from "../../images/arrow-right-white.svg";

export const useStyles = createUseStyles({
  canDoYouContainer: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 8,
    textDecoration: "none"
  },
  canDoYouText: {
    padding: "0 24px",
    color: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    height: 64,
    "@media (min-width: 1200px)": {
      lineHeight: "1.1 !important"
    }
    // "&:after": {
    //   content: "''",
    //   width: 16,
    //   height: 16,
    //   background: `url(${arrow}) no-repeat, center/24px`,
    //   marginLeft: 12
    // }
  }
});
